export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";